import { classNames } from '../utilities';

export const DeliveredEmailIcon = ({
  fill = '#5bd2ad',
  id,
  className,
  onClick,
  isClickable = true,
}) => {
  return (
    <svg
      className={classNames(
        isClickable ? 'cursor-pointer' : '',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      width="17"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.46955 1.43207L8.23049 5.79338L14.9914 1.43207H1.46955ZM1.38805 13.4095C1.00301 13.4095 0.675399 13.2706 0.405231 12.9929C0.135077 12.7151 0 12.3783 0 11.9824V1.43207C0 1.03484 0.135077 0.696856 0.405231 0.418123C0.675399 0.139375 1.00301 0 1.38805 0H15.0933C15.4797 0 15.8084 0.139375 16.0795 0.418123C16.3507 0.696856 16.4862 1.03484 16.4862 1.43207V6.78693C16.4862 6.98834 16.4159 7.15762 16.2754 7.29476C16.1348 7.43189 15.9514 7.50045 15.7253 7.50045C15.546 7.50045 15.3958 7.43786 15.2748 7.31267C15.1538 7.18747 15.0933 7.03393 15.0933 6.85205V2.72024L8.59542 6.93642C8.54275 6.97175 8.42154 7.00282 8.23181 7.02963C8.15591 7.02963 8.09191 7.02265 8.03979 7.00868C7.98769 6.99472 7.93123 6.9721 7.8704 6.94084L1.38805 2.72024V11.9824H6.72329C6.9192 11.9824 7.08385 12.0513 7.21723 12.1892C7.35062 12.327 7.41732 12.4972 7.41732 12.6996C7.41732 12.9021 7.35062 13.071 7.21723 13.2064C7.08385 13.3418 6.9192 13.4095 6.72329 13.4095H1.38805ZM11.3884 13.2797L15.8391 8.70894C15.9769 8.56658 16.1364 8.49889 16.3176 8.50587C16.4988 8.51286 16.6579 8.58753 16.7947 8.72989C16.9316 8.87227 17 9.03991 17 9.23282C17 9.42573 16.9324 9.59171 16.7971 9.73075L11.8796 14.7864C11.7387 14.9288 11.5744 15 11.3866 15C11.1988 15 11.0357 14.9288 10.8972 14.7864L8.53122 12.349C8.39274 12.2099 8.3277 12.0438 8.33613 11.8505C8.34453 11.6572 8.41636 11.4898 8.5516 11.3481C8.68935 11.2058 8.85142 11.1346 9.03781 11.1346C9.22419 11.1346 9.38662 11.2058 9.52511 11.3481L11.3884 13.2797Z"
        fill="#FF7F50"
        fillOpacity="0.94"
      />
    </svg>
  );
};
